import styled from 'styled-components';

export const ReviewsContainer = styled.main`
`;

export const ReviewsTwoColumnContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1130px;
  margin: 0 auto;
  padding: 30px 25px 0;

  @media (min-width: 768px) {
    align-items: flex-start;
    padding: 50px 25px;
  }

  @media (min-width: 1024px) {
    padding: 75px 25px;
  }
`;

export const ReviewsWrapper = styled.div`
  max-width: 750px;
  width: 100%;
`;

export const ReviewsList = styled.ul`
  list-style: none;

  li:not(:last-child) {
    border-bottom: 1px solid #ebebeb;
  };
`;

export const ReviewsLayoutAside = styled.aside`
  position: fixed;
  z-index: 2;
  bottom: 0;
  left: 0;
  
  display: ${({ hasSelectedHotel }) => hasSelectedHotel ? 'block' : 'none' };
  width: 100%;
  
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  background-color: white;

  @media(min-width: 768px) {
    position: sticky;
    top: 120px;
    
    display: block;    
    max-width: 315px;
    margin-left: 65px;
    padding: 30px;
    padding-top: 45px;
  }
`;

export const ReviewsHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const ReviewsHeader = styled.h2`
  margin: 0;
  
  font-size: 22px;
  color: ${({ theme }) => theme.black};

  @media(min-width: 768px) {
    font-size: 36px;
  };
`;

export const ReviewsTotalCount = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  
  color: ${({ theme }) => theme.black};
  font-size: 14px;

  span {
    margin-right: 5px;
    
    font-weight: 700;
  }
  
  svg {
    margin-right: 10px;
    flex-shrink: 0;
  }
`;

export const ReviewsNothingFound = styled.h2`
  width: 100%;
  margin: 100px 0;
  
  font-size: 40px;
  line-height: 1;
  text-align: center;
  opacity: 0.4;
  
  pointer-events: none;
  user-select: none;
`;
